module.exports = __webpack_public_path__ + "img/n253.27b37387.png";